import React, { useContext } from "react"
import styled from "styled-components"

import { Content, FullWrapper, Title, Subtitle } from "Styles"
import { theme } from "Theme"

import { ThemeContext, ActionButton, ActionButtonAlt, LinkButtonAlt, LinkButton, Utils} from "Components"
import { GatsbyImage } from "gatsby-plugin-image"
import Config from "Data"
const Wrapper = styled.section`
  width: 100%;
  color: ${({ mode }) => (mode === "dark" ? theme.colors.white.base : theme.colors.black.base)};
  background-color: ${({ mode }) => (mode === "dark" ? theme.colors.black.base : theme.colors.white.base)};
  border-color: ${({ mode }) => (mode === "light" ? theme.colors.white.base : theme.colors.black.base)};
  border-radius: ${theme.borderRadius.ui};
  overflow: hidden;
  box-shadow: ${theme.shadow.feature.small.default};
  z-index: 3;
  display: grid;
  min-height: 260px;
  align-items: start;
  align-content: space-around;
  @media (min-width: ${theme.breakpoints.s}) {
    
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-columns:  1fr 1fr 1fr;
    position:absolute ;
  top:-150px ;
  }
  @media (min-width: ${theme.breakpoints.l}) {
    grid-template-columns:  1fr 1fr 1fr;
    position:absolute ;
  top:-150px ;
  }
  max-width: ${theme.layout.base};
  border-bottom: 3px solid ${Utils.BrandColor(Config.brand)};
 
`

// const StyledBackgroundImage = styled(GbiBridged)`
//   display: none;
//   @media (min-width: ${theme.breakpoints.s}) {
//   }
//   @media (min-width: ${theme.breakpoints.m}) {
//     display: block;
//   }
//   @media (min-width: ${theme.breakpoints.l}) {
//   }
// `

const ColumnBox = styled.div`
padding: 1rem 2rem;
`
const FeaturedSectionColumns = ({
  track,
  dark,
  title,
  subtitle,
  image,
  children,
  cta_url1_text,
  cta_url1,
  cta_url2_text,
  cta_url2,
  cta_action1_text,
  cta_action1,
  cta_action2_text,
  cta_action2,
}) => {
  const { mode } = useContext(ThemeContext)
  return (
    <FullWrapper style={{ position: 'relative' }}>
      <Wrapper image={image} mode={dark ? "dark" : mode}>
        <ColumnBox>
          <div>  <h3>
            Attended by the biggest brands</h3></div>
          <div>
            CFO.org events bring forth an audience of financial leaders from the biggest brands and enterprises globally. Leading digital transformation takes collaboration and #ITstartsHere.
          </div>

        </ColumnBox>
        <ColumnBox>
          <div>  <h3>
            Who's who of Enterprise Finance
          </h3></div>
          <div>
            Enterprise finance has evolved and the landscape is now digital. Our attendees lead these initiatives and walk the line of digital transformation.
          </div>

        </ColumnBox>
        <ColumnBox>
          <div>  <h3>
            Intimate Collaboration</h3></div>
          <div>
            By Invitation Only our attendees engage in a day of thought leading panels, insightful roundtables and eye opening keynotes.
          </div>
        </ColumnBox>
      </Wrapper>
    </FullWrapper>
  )
}

export default FeaturedSectionColumns
